import React, { ReactElement, ForwardedRef } from 'react';
import FormatService from '../../services/format-service';
import ScreenService from '../../services/screen-service';
import useStylesContentListContainer from './content-list-container.styles';

const ContentListContainer: ReactMemoComponent = React.memo(React.forwardRef((
  props: ReactComponentProps,
  ref: ForwardedRef<HTMLDivElement>,
): ReactElement => {
  const ITEM_BATCH_DELAY: number = 200;

  const {
    isDefault,
    maxHeight,
    className,
    onScroll,
    children,
  } = props;

  const { classes } = useStylesContentListContainer();

  const defaultClassName: string | undefined = isDefault ? classes.contentListContainerDefault : undefined;

  return (
    <div
      ref={ref}
      className={FormatService.formatClassNames(classes.contentListContainer, defaultClassName, className)}
      style={{
        maxHeight: maxHeight || 'none',
      }}
      onScroll={onScroll ? ScreenService.withDelay(onScroll, ITEM_BATCH_DELAY) : undefined}
    >
      {children}
    </div>
  );
}));

export default ContentListContainer;
